import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Tooltip } from '@codex/basics';
import { wasPriceDateTrimYear } from '@codex/helpers';
import ProductPriceBlockWrapper, { VARIANT_FO_SITE_COMPARE_SLIDER }
  from '../../ProductPriceBlock/ProductPriceBlockWrapper';

const StyledTooltip = styled(Tooltip)`
  width: 360px;
  height: auto;
  padding: 15px 0 15px 15px;
  ${(props) => props.firstChild && css`
    &:before {
     @media only screen and (max-width: 1359px) {
        left: 15%;
      }   
    }   
  `};
`;

const ProductTitle = styled.div`
  font-size: 12px;
  display: inline-block;
  text-decoration: none;
  padding-right: 10px;
`;

const ProductImg = styled.img`
  width: 80px;
  height: 70px;
  margin-top: 5px;
  margin-right: 15px;
  display: inline-block;
  vertical-align: top;
`;

const ProductInfo = styled.div`
  margin-top: 5px;
  display: flex;
`;

export default function CompareProductTooltip(props) {

  return (
    <StyledTooltip
      arrow={'bottom'}
      type={'neutral'}
      firstChild={props.firstChild}
    >
      
      <div>
        <a
          href={props.productUrl}
          onClick={props.onProductClick()}
        >
          <ProductTitle href={props.productUrl}>
            {props.brand}
            {' '}
            {props.title}
          </ProductTitle>
        </a>

        <ProductInfo>
          <a
            href={props.productUrl}
            onClick={props.onProductClick()}
          >
            <ProductImg src={props.imageUrl} alt={props.imageAlt} />
          </a>

          <ProductPriceBlockWrapper
            variant={VARIANT_FO_SITE_COMPARE_SLIDER}
            currentPrice={props.prices.price}
            savingsPrice={props.prices.savingsPrice ? props.prices.savingsPrice : undefined}
            wasPrice={props.prices.wasPrice ? props.prices.wasPrice : undefined}
            wasPriceFrom={props.prices.wasPriceFrom
              ? wasPriceDateTrimYear(props.prices.wasPriceFrom) : undefined}
            wasPriceTo={props.prices.wasPriceTo
              ? wasPriceDateTrimYear(props.prices.wasPriceTo) : undefined}
            isOutOfStock={props.isOutOfStock}
          />

        </ProductInfo>
      </div>

    </StyledTooltip>
  );
}

CompareProductTooltip.disaplayName = 'ComparePanelProductTooltip';

CompareProductTooltip.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  productUrl: PropTypes.string,
  prices: PropTypes.shape({
    price: PropTypes.string,
    savingsPrice: PropTypes.string,
    wasPrice: PropTypes.string,
    wasPriceFrom: PropTypes.string,
    wasPriceTo: PropTypes.string
  }).isRequired,
  imageAlt: PropTypes.string,
  brand: PropTypes.string,
  isOutOfStock: PropTypes.bool.isRequired,
  translations: PropTypes.shape({
    savingsPriceTranslation: PropTypes.string.isRequired,
    wasPriceTranslation: PropTypes.string.isRequired,
    fromDateTranslation: PropTypes.string.isRequired,
    toDateTranslation: PropTypes.string.isRequired
  }).isRequired,
  firstChild: PropTypes.bool,
  onProductClick: PropTypes.func
};

CompareProductTooltip.defaultProps = {
  productUrl: '#',
  imageAlt: '',
  brand: '',
  firstChild: false,
  onProductClick: () => {}
};
